<template>
  <div class="page-list">
    <div class="border-bottom">
      <div class="title" v-if="!id">新建开票申请</div>
      <div class="title" v-else>编辑开票申请</div>
      <button type="button" class="btn btn-secondary float-right" @click="save">仅保存</button>
      <button type="button" class="btn btn-secondary float-right red" @click="isSubmit=true;save()">提交开票申请</button>
    </div>
    <div class="row">
      <div style="width:120px;">选择发票抬头</div>
      <div class="col-lg-4">
        <select class="form-control" v-model="invoiceIdx">
          <option :value="''">--选择发票抬头--</option>
          <option :value="it.idx" v-for="it in invoiceList" :key="it.idx">{{ it.title }}</option>
        </select>
      </div>
      <div style="width:120px;margin-left:100px;">纳税识别号</div>
      <div class="col-lg-4">{{ invoice.taxNumber }}</div>
    </div>
    <div class="row">
      <div style="width:120px;">选择发票类型</div>
      <div class="col-lg-4">
        <select class="form-control">
          <option>增值税专用发票</option>
        </select>
      </div>
      <div style="width:120px;;margin-left:100px;">开户银行</div>
      <div class="col-lg-4">{{ invoice.bankName }}</div>
    </div>
    <div class="row">
      <div style="width:120px;">发票内容</div>
      <div class="col-lg-4">
        <input type="radio" v-model="requireContent" value="PART" /> 汽车零件
        <span style="margin:15px"></span>
        <input type="radio" v-model="requireContent" value="COMMODITY" /> 商品明细
      </div>
      <div style="width:120px;;margin-left:100px;">银行账号</div>
      <div class="col-lg-4">{{ invoice.bankAccount }}</div>
    </div>
    <div class="row">
      <div style="width:120px;">开票金额</div>
      <div class="col-lg-4">
        <input type="text" v-model="allAmount" class="form-control" :disabled="true" placeholder="自动计算出已选的总可开票金额" />
      </div>
    </div>
    <div class="add-item">
      <button class="btn btn-secondary" @click="getOrderList();showDialog=true">选择可供开票的项目</button>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>订单号</th>
          <th>物流单号</th>
          <th style="width:150px;">可开票金额(元)</th>
          <th style="width:150px;">发生日期</th>
          <th style="width:100px;">操作</th>
        </tr>
      </thead>
      <tbody style="height: 450px;">
        <tr v-for="item in selectList" :key="item.id">
          <td>{{ item.salesOrderNumber }}</td>
          <td>{{ item.logisticsNumber }}</td>
          <td style="width:150px;">{{ (item.amount || item.invoicedAmount) | toMoney }}</td>
          <td style="width:150px;">{{ item.occurDate | toShortDate }}</td>
          <td style="width:100px;">
            <button type="button" class="btn btn-secondary btn-sm" @click="remove(item)">移除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <DialogBox :w="1000" :h="600" :show="showDialog">
      <div class="item-wrap">
        <div class="tit border-bottom">
          <strong>选择可供开票的项目</strong>
          <button type="button" class="btn btn-secondary btn-sm float-right" @click="showDialog=false">关闭</button>
        </div>
        <div class="cont">
          <button type="button" class="btn btn-secondary btn-sm" @click="select">选择</button>
          <SearchField style="float:right;width:250px;" :small="true" :value.sync="searchText" @submit="search" placeholder="收款单位, 发货单号, 订单号"></SearchField>
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width:42px;">
                  <div class="custom-control custom-control-inline custom-control-nolabel custom-checkbox">
                    <input type="checkbox" class="custom-control-input" v-model="checkedAll" />
                    <label class="custom-control-label" @click.stop="checkAll">CheckAll</label>
                  </div>
                </th>
                <th>订单号</th>
                <th>物流单号</th>
                <th style="width:150px;">可开票金额(元)</th>
                <th style="width:150px;">发生日期</th>
              </tr>
            </thead>
            <tbody style="height:440px;">
              <tr v-for="item in orderList" :key="item.id">
                <td style="width:42px;">
                  <div class="custom-control custom-control-inline custom-control-nolabel custom-checkbox">
                    <input v-model="item.checked" type="checkbox" class="custom-control-input" />
                    <label class="custom-control-label" @click.stop="checkItem(item)">CheckAll</label>
                  </div>
                </td>
                <td>{{ item.salesOrderNumber }}</td>
                <td>{{ item.logisticsNumber }}</td>
                <td style="width:150px;">{{ item.amount | toMoney }}</td>
                <td style="width:150px;">{{ item.occurDate | toShortDate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </DialogBox>
  </div>
</template>

<script>
import SearchField from "@components/SearchField.vue";
import DialogBox from "@components/DialogBox.vue";

export default {
  components: {
    SearchField,
    DialogBox
  },
  data() {
    return {
      id: "",
      detail: {},
      checkedAll: false,
      searchText: "",
      showDialog: false,
      invoiceList: [],
      invoiceIdx: "",
      requireContent: "PART",
      orderList: [],
      selectList: [],
      isSubmit: false
    };
  },
  computed: {
    invoice() {
      let arr = this.invoiceList.filter(it => it.idx === this.invoiceIdx);
      if (arr.length) {
        return arr[0];
      } else {
        return {};
      }
    },
    allAmount() {
      let count = 0;
      this.selectList.forEach(it => {
        if (it.amount) count += Number(it.amount);
        if (it.invoicedAmount) count += Number(it.invoicedAmount);
      });
      return this.$options.filters.toMoney(count);
    }
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getData();
    } else {
      this.getInvoiceList();
    }
  },
  methods: {
    save() {
      if (this.invoiceIdx === "") return $msg.warning("请选择发票抬头!", 3);
      let idList = [];
      this.selectList.forEach(it => idList.push(it.id || it.receivableId));
      let params = {
        invoiceIdx: this.invoiceIdx,
        kind: "VAT_SPECIAL",
        requireContent: this.requireContent,
        receivableIds: idList
      };
      if (this.id) params.id = this.id;
      this.$post("/pass/salesInvoice/save", params)
        .then(id => {
          $msg.msg("保存成功。");
          if (this.isSubmit) {
            this.$post("/pass/salesInvoice/submit/" + id, params)
              .then(() => this.$router.replace("/buyer/apply/" + id))
              .catch(err => {});
          }
        })
        .catch(err => {});
    },
    select() {
      this.selectList = this.orderList.filter(it => it.checked);
    },
    remove(item) {
      this.checkedAll = false;
      this.orderList.forEach(it => {
        if (it.id == item.id || it.id == item.receivableId) it.checked = false;
      });
      if (item.id) this.selectList = this.selectList.filter(it => it.id != item.id); // 新添加的
      if (item.receivableId) this.selectList = this.selectList.filter(it => it.receivableId != item.receivableId); // 之前保存的
    },
    getOrderList() {
      if (this.orderList.length) return;
      this.$post("/pass/receivable/queryForPurchase", {
        criteria: {
          forApply: true //采购商开票申请过滤
        },
        limit: 128,
        offset: 0
      })
        .then(res => {
          res.results.forEach(it => {
            it.checked = false;
            this.selectList.forEach(item => {
              if (it.id == item.receivableId) it.checked = true;
            });
          });
          this.orderList = res.results;
        })
        .catch(err => {});
    },
    getInvoiceList() {
      this.$get("/spms/myProfiles/getOrgProfile/")
        .then(res => {
          this.invoiceList = res.invoiceInfos || [];
          this.invoiceList.forEach(it => {
            if (it.bankAccount == this.detail.bankAccount) this.invoiceIdx = it.idx;
          });
        })
        .catch(err => {});
    },
    getData() {
      this.$get("/pass/salesInvoice/get/" + this.id)
        .then(res => {
          this.detail = res;
          this.requireContent = res.requireContent.name;
          this.selectList = res.relations;
          this.getInvoiceList();
        })
        .catch(err => {});
    },
    search() {},
    checkAll() {
      this.checkedAll = !this.checkedAll;
      this.orderList.forEach(it => (it.checked = this.checkedAll));
    },
    checkItem(it) {
      it.checked = !it.checked;
      let noChecked = this.orderList.filter(item => !item.checked);
      if (!noChecked.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url("~@assets/less/vars.less");
table {
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    width: calc(100% - 17px);
  }
  tbody {
    display: block;
    overflow-y: scroll;
  }
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  td {
    vertical-align: middle;
  }
}

.page-list {
  .border-bottom {
    overflow: hidden;
    .title {
      margin-bottom: 20px;
      font-size: 24px;
      line-height: 36px;
      float: left;
    }
    .btn {
      margin: 1px 1px 0 15px;
    }
  }
  .row {
    padding: 10px 15px;
    line-height: 36px;
  }
  .add-item {
    margin: 20px 0;
    .btn {
      font-weight: 700;
    }
  }
  .item-wrap {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.35);
    .tit {
      padding: 10px 20px;
      font-size: 16px;
    }
    .cont {
      padding: 10px 20px;
    }
  }
}
</style>